import { getBrand } from "@/utils/theme"

// import store from '@/store';
export const THEME_OPT = {
    PROART: 'THEME_PROART',
    ASUS: 'THEME_ASUS',
}

export const BRAND = {
    PROART: 'ProArt',
    ASUS: 'ASUS',
}
export const FEATURENAME = {
    DASHBOARD: 'Dashboard',
    DASHBOARDDEFAULT: 'Dashboard Default',
    DEVICE: 'Device Management',
    DEVICEDETAIL: 'Back',
    GROUP: 'Group Management',
    GROUPDETAIL: 'Back ',
    NOTIFICATION: 'Notification Center',
    CALIBRATION: 'Color Calibration',
    CALIBRATIONDEFAULT: 'Color Calibration Default',
    ADVANCED: 'Advanced Setting',
    MODIFY: 'Modify Setting',
    CLOUD: 'Cloud Target',
    LOGIN: 'Login',
    TASK: 'Task Management',
}


export const CONNECTION = {
    1: 'online',
    0: 'offline',
    2: 'waiting',
}


export const IMPLEMENTATION = {
    0: 'Fail',
    1: 'Success',
    2: 'Wait',
}

export const ACTIONBAR = { ///不能亂改
    DEVICELIST: 'deviceList',
    SETTING: 'setting',
    DOWNLOAD: 'download',
    VIEWAPP: 'viewAppointment',
    VIEWHIS: 'viewHistory',  //Executed Tasks
    SETCAL: 'setCalibration',
    UNBIND: 'unbind',
    UNGROUP: 'Ungroup only',
    UNGROUPANDUNBIND: 'Ungroup and unbind all devices together',
}


export const ACTIONBARWORD = {  ///不能亂改
    'Device List': 'deviceList',
    'Settings': 'setting',
    'Download CSV': 'download',
    'View Appointment': 'viewAppointment',
    'View History': 'viewHistory',  //Executed Tasks
    'Set Calibration': 'setCalibration',
}


export const TASKTAB = { ///不能亂改
    EXECUTED: 'executed',
    APPOINTMENT: 'appointment',

}



export const POPUP = {
    NORMAL: 'noraml',
    DEMO: 'demo',
    GROUPADD: 'group-add',
    UNGROUP: 'un_group',
    UNBIND: 'un_bind',
    DEVICEDETAIL: 'deviceDetail',
    MODIFYGROUP: 'modifyGroup',
    CONTACT: 'contact',
    IMPLEMENTATION: 'implementation ',
    DEVICEUNBIND: 'device_unbind',
    DEVICERSET: 'device_reset',
    DEVICENOTIFICATION: 'notification',
    DETAILS: 'details',
    GLOBALADDDEVICE: 'global-add-device',
    CUSTOMIZED: 'select-customized-devices',
    SAVECUSTOMIZED: 'save-customized-target',
    MODIFYSETTING: 'modify-setting',
    SAVEMODIFY: 'modify-save',
    LICENSE: 'license',
    PRIVACY: 'privacy',
    AGREEMENT: 'agreement',
    IMPORTCSV: 'import-csv',
    EXCEED: 'exceed', //csv
    DEVICEMODELERROR: 'device_model_error',
    APIERROR: 'modal-api-error',
    LEAVEADVANCED: 'leave_advanced',
    DEVICETABLEFILTER: 'device_table_filter',
    OVERFLOW: 'overflow_device', //device
    BRIGHTLIMIT: 'brightness_limit',
    CLEARDEVICEANDGROUP: 'clear_device_and_group',
    CUSTOMIZEDGROUP: 'select-customized-groups',
    PRESETLIMIT: 'preset_mode_limit',
}


export const BTN = {
    CONFIRM: 'confirm',
    CANCEL: 'cancel',
}

export const REPEAT_TYPE = {
    2: 'month',
    1: 'week',
}

export const PRESET_TITLE = {
    color_range: 'Dynamic Rang',
    gamma: 'gamma',
    color_temperature: 'Color Temperature',
    brightness: 'Brightness',
    calibrator: 'Calibrator Type',
    gamut: 'Gamut',
    eotf: 'EOTF',
}

const brand = getBrand();
export const USERMODE = {
    0: `${brand} Preset`,
    1: 'User Mode 1',
    2: 'User Mode 2',
    3: 'User Mode 3',
}




export const UNIT = {
    NTM2: 'cd/m²',
    K: 'k',
    NODATA: '- - -', //no data show '-'
}

export enum ATTR_NAME {
    CREATE_DATE = 'createDate',
    TARGET_NAME = 'targetName',
    MODEL_NAME = 'modelName',
    DYNAMIC_RANGE = 'dynamicRange',
    GAMUT = 'gamut',
    BRIGHTNESS = 'brightness',
    COLOR_TEMP = 'colorTemperature',
    GAMMA = 'gamma',
    EOTF = 'eotf',
    COORD = 'coordinate',
    STANDARD_VALUE = 'standard', // white point standard value
    GAMUT_CUSTOM = 'gamutCustom', // custom gamut value
}

export const FILTER_TYPE = {
    MODEL: 'model',
    GROUP: 'group',
    ALL: 'all',
    RANGE: 'range',
}


export const CHECKING_STATUS = { // for csv upload status
    ALL: -1,
    BINDABLE: 3,
    BOUND: 4,
    ERROR: 0,
    BOUNDBY: 1,
    INVITATEBY: 2
}

export const SORT = {
    UP: 'up',
    DOWN: 'down',
}

export const FUNC_NAME = {
    TARGET: 'target',
}


export const ENV = {
    DEV: 'dev',
    DEV_ONLINE: 'dev-online',
    MOCK: 'mock',
    PROD: 'prod',
    STAGING: 'staging',
    ADC: 'adc',
}

export const LANG = {
    EN: 'en',
    TW: 'tw',
    LANG: 'lang',
    CH: 'ch',
    JP: 'japanese',
    DUTCH: 'dutch',
    FRE: 'french',
    GER: 'german',
    IND: 'indonesian',
    ITA: 'italian',
    KOR: 'korean',
    POLISH: 'polish',
    ROMANIAN: 'romanian',
    RUSSIAN: 'russian',
    SPAN: 'spanish',
    SWEDISH: 'swedish',
    THAI: 'thai',
    TUR: 'turkish',
    UKR: 'ukrainian',
    VIE: 'vietnamese',

}


export const BRIGHTNESSUNIT = {
    lmax: 'Lmax',
    lmin: 'Lmin',
}

export const BRIGHTNESSMAX = {
    1200: 'Max',
}

export const ERRORDESC = {
    0: '__errorDesc.__unknownError',
    1: '__errorDesc.__userCancelled',
    2: '__errorDesc.__overdueAndNotExecuted',
    3: '__errorDesc.__deviceIsNotBound',
    4: '__errorDesc.__monitorDisconnected',
    5: '__errorDesc.__monitorUsbThunderboltDisconnected',
    6: '__errorDesc.__calibratorError',
    7: '__errorDesc.__calibratorPoorlyPlacedDeltaEOutOfSpecEtc',
    100: '__errorDesc.__calibrationError',
    102: '__errorDesc.__calibrationError',
    106: '__errorDesc.__calibrationError',
    107: '__errorDesc.__calibrationError',
    108: '__errorDesc.__calibrationError',
    110: '__errorDesc.__calibrationError',
    111: '__errorDesc.__calibrationError',
    112: '__errorDesc.__calibrationError',
    113: '__errorDesc.__calibrationError',
    114: '__errorDesc.__calibrationError',
    115: '__errorDesc.__calibrationError',
    116: '__errorDesc.__calibrationError',
    117: '__errorDesc.__calibrationError',
    199: '__errorDesc.__calibrationError',
    255: '__errorDesc.__computerTimedOut',
    300: '__errorDesc.__otherDeviceError',
    400: '__errorDesc.__calibrationError',
    401: '__errorDesc.__appointmentConflict',
    402: '__errorDesc.__appointmentNotExist',
    500: '__errorDesc.__serverError', //__serverError
    501: '__errorDesc.__serverError',
    600: '__errorDesc.__otherAccountOrDeviceBindingError',

}

export const MODELIMG = {
    'default': 'default.png',
    'PA27UCX': 'PA27UCX.png',
    'PA32UCG': 'PA32UCG.png',
    'PA32UCR': 'PA32UCR.png',
    'PA32UCX': 'PA32UCX.png',
    'PQ22UC': 'PQ22UC.png',
    'PA27DCE': 'PA27DCE.png',
    'PA32DC': 'PA32DC.png',
    'PA24US': 'PA24US.png',
    'PA32UCXR': 'PA32UCXR.png',
    'PA32KCX': 'PA32KCX.png',
    'PA27UCGE': 'PA27UCGE.png',
    'PA27UCDMR': 'PA27UCDMR.png',
    'PA32UCDM': 'PA32UCDM.png',
    'PA32UCE': 'PA32UCE.png',
    'PA32UCDMR': 'PA32UCDMR.png',
    'PA27USD': 'PA27USD.png',
    'PA32USD': 'PA32USD.png',
    'HA2441A': 'HA2441A.png',
    'HA2741A': 'HA2741A.png',
    'HA3281A': 'HA3281A.png',
    'MH2441A': 'MH2441A.png',
    'MH2741A': 'MH2741A.png',
    'MH3281A': 'MH3281A.png',



}
